<template>
  <v-menu open-on-click top offset-y>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" class="mr-2" :color="getColorIcone" :title="title">{{
        icone
      }}</v-icon>
    </template>
    <v-list dense nav max-width="200">
      <v-subheader
        ><v-icon left>mdi-alert-outline</v-icon
        ><b>{{ getMessage }}</b></v-subheader
      >
      <v-divider></v-divider>
      <v-list-item
        @click="
          {
          }
        "
        ><v-list-item-icon>
          <v-icon medium left color="red">mdi-cancel</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Non</v-list-item-title>
      </v-list-item>
      <v-list-item @click="confirmer()"
        ><v-list-item-icon>
          <v-icon medium left color="green">mdi-checkbox-marked-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Oui</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ActionConfirmation",
  props: {
    icone: String,
    colorIcone: String,
    title: String,
    loading: Boolean,
    message: { type: String, required: false },
  },
  data() {
    return {};
  },
  methods: {
    confirmer() {
      this.$emit("ok");
    },
  },
  computed: {
    getMessage() {
      if (this.message != undefined) {
        return this.message;
      } else {
        return "êtes vous sûr(e) ?";
      }
    },
    getColorIcone() {
      if (this.colorIcone != undefined) {
        return this.colorIcone;
      } else {
        return "primary";
      }
    },
  },
};
</script>
